module.exports = __webpack_public_path__ + "img/google-plus-circle.1fc786fe.svg";